// Mirror of `format-label` in @tournament-suite/league-rules — the viewer builds
// with CRA, which cannot compile the workspace package, so the wording lives here too.
import type { MatchRules, ScoringSystem } from './scoring-types';

function setCountLabel(rules: MatchRules): string {
  const setsPlayed = rules.setsPlayed ?? null;

  if (setsPlayed === null) {
    return `BO${rules.bestOf}`;
  }

  if (setsPlayed === 1) {
    return '1 set';
  }

  return setsPlayed < 5 ? `${setsPlayed} sety` : `${setsPlayed} setów`;
}

function thresholdLabel(rules: MatchRules): string {
  if (!rules.withAdvantage) {
    return 'bez przewagi';
  }

  if (rules.betterPoint === null) {
    return 'przewaga bez limitu';
  }

  return `punkt graniczny ${rules.betterPoint}`;
}

function dominantUpTo(rules: MatchRules, scoring: ScoringSystem): number | null {
  if (scoring.dominantMargin === null) {
    return null;
  }

  return Math.max(0, rules.pointsPerSet - scoring.dominantMargin);
}

export function setFormatLabel(rules: MatchRules): string {
  return `do ${rules.pointsPerSet}, ${setCountLabel(rules)}, ${thresholdLabel(rules)}`;
}

export function scoringLabel(rules: MatchRules, scoring: ScoringSystem): string {
  if (!scoring.perSet) {
    return 'klasyczny';
  }

  const upTo = dominantUpTo(rules, scoring);

  if (upTo === null) {
    return `better point — ${scoring.winPoints} pkt za set`;
  }

  return `better point — ${scoring.winPoints} pkt za set, ${scoring.dominantWinPoints} pkt przy wygranej do ${upTo}`;
}

export function matchFormatLabel(
  rules: MatchRules,
  scoring: ScoringSystem | null | undefined
): string {
  if (!scoring) {
    return setFormatLabel(rules);
  }

  return `${setFormatLabel(rules)} · ${scoringLabel(rules, scoring)}`;
}
